<div class = "row ml-0 mr-0">
    <div class = "col-12 not-found-task mt-5">
        Oops!! Page not Found
    </div>
</div>